import { MutationTree } from "vuex";
import { DataImplementationsWithMessagesCountState, DataImplementationsWithMessagesCount } from "./model";

const mutations: MutationTree<DataImplementationsWithMessagesCountState> = {
  setDataImplementationsWithMessagesCounts(state, dataImplementationsWithMessagesCounts: DataImplementationsWithMessagesCount[]) {
    state.dataImplementationsWithMessagesCounts = dataImplementationsWithMessagesCounts
  },
}

export default mutations;
